module.exports = __webpack_public_path__ + "static/img/bbsbackground.5518ba1a.jpg";